import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ListPagination from '../../../components/UI/ListPaginationUl';
import PlantListItem from './PlantListItem';
import * as plantAction from '../../../actions/plantAction';
import BackButton from '../../../components/UI/BackButton';
import { TitleUI, SubtitleUI } from '../../../components/UI/LabelTitleUI';
import { translate, showMessageToastCustom } from '../../../utils/util';
import PlantService from '../../../services/PlantService';
import M from 'materialize-css/dist/js/materialize';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { Button, Input, SelectItem } from '../../../components/UI/ComponentsUI';
import { ENUMS } from '../../../utils/constants';
import { startLoading, endLoading } from '../../../actions/loadingAction';
import { Row, Modal } from 'react-materialize';

const PlantList = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [plants, setPlants] = useState([]);
    const [instanceM, setInstanceM] = useState();
    const [selectedItems, setSelectedItems] = useState([]);
    const [modalOpen, setModalOpen] = useState(false)
    const [filter, setFilter] = useState(
        {
            name: undefined,
            dateStart: undefined,
            dateEnd: undefined,
            updatedBy: undefined,
            latitude: undefined,
            longitude: undefined
        });

    useEffect(() => {
        if (props.plants?.items?.length > 0) {
            if (plants.length > 0 && currentPage === 0) {
                setPlants(props.plants.items);
            } else {
                setPlants((prevState) => ([...prevState, ...props.plants.items]));
            }
        } else {
            setPlants([]);
        }
        // eslint-disable-next-line
    }, [props?.plants?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        onFilter(true);
        return () => {
            setPlants([]);
        }
        // eslint-disable-next-line
    }, []);

    const onSelectItemChange = (plant) => {
        props.setPlant(plant);
    };

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeSelectItem = (event) => {
        filter.updatedBy = event;
    };

    const removeSelected = (item) => {
        let list = [];
        Object.assign(list, selectedItems);
        let index = list.findIndex(x => x.plantId === item.plantId)
        list.splice(index, 1);
        setSelectedItems(list)
    }

    const addSelectedItem = (item) => {
        if (selectedItems.some(e => e.plantId === item.plantId)) {
            removeSelected(item)
        } else {
            let list = [];
            Object.assign(list, selectedItems);
            list.push(item)
            setSelectedItems(list);
        }
    }

    const handleSelected = () => {
        if (selectedItems.length === 0) {
            return showMessageToastCustom(translate('warning', 'general'), "Nenhum item selecionado", 3000, 'mdi mdi-alert-circle-outline red-text');
        }
        else {
            setModalOpen(true);
        }
    }

    const handleBack = () => {
        onFilter(true);
        setModalOpen(false);
        setSelectedItems([]);
    }

    const onConfirmModal = () => {
        const selectedIds = selectedItems.map(x => x.plantId);
        props.deleteSelected(selectedIds, () => {
            handleBack()
        });
    }

    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport")) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
                setPlants([]);
            }
            props.showLoading();
            props.getPlants(props.user.vision, filter, {
                PageSize: ENUMS.ePagination.PageSize.value,
                PageIndex: currentPageList
            }, () => {
                props.hideLoading();
                instanceM[1].close();
            });
        }
    }

    const renderItem = (item, index) => {
        return (
            <div className="row" key={item.plantId} style={{ marginBottom: '0px' }}>
                <ul className="col s12" style={{ padding: '0', marginTop: '0', marginBottom: '0'}}>
                    <li
                        key={`oi-${item.id += 1}`}
                    >

                        <div
                            className="row"
                            key={`${item.id}`}
                            style={{backgroundColor:'white', padding: '12px', marginBottom:'0', borderBottomWidth: '0.7px', borderBottomStyle: 'solid', borderBottomColor: 'rgb(224, 224, 224)', borderTopWidth: '0.7px', borderTopStyle: 'solid', borderTopColor: 'rgb(224, 224, 224)'}}
                        >

                            <PlantListItem
                                // eslint-disable-next-line react/no-array-index-key
                                key={`oi-${index}`}
                                route={{ pathname: '../plant/insert', state: { update: true } }}
                                data={item}
                                onSelectChange={() => onSelectItemChange(item)}
                                onCheck={() => addSelectedItem(item)}
                            />

                        </div>
                    </li>
                </ul >
            </div >
        )
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <TitleUI icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                    <SubtitleUI icon="mdi mdi-domain" label={translate('menu.plant', 'configuration')} />
                </div>
                <div className="container" style={{ marginTop: '0px' }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('plant:filters')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.dateStart}
                                            type="date"
                                            label={translate('plant:fields.dateStart')}
                                            id="dateStart"
                                            name="dateStart"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.dateEnd}
                                            type="date"
                                            label={translate('plant:fields.dateEnd')}
                                            id="dateEnd"
                                            name="dateEnd"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.name}
                                            type="text"
                                            label={translate('plant:fields.name')}
                                            id="name"
                                            name='name'
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <SelectItem
                                            id="updatedBy"
                                            name="updatedBy"
                                            value={filter.updatedBy}
                                            label={translate('plant:fields.user')}
                                            onChange={(event) => onChangeSelectItem(event)}
                                            onChangeData={onChangeSelectItem}
                                            data={props.usersFromElog ? props.usersFromElog.map(item => {
                                                return {
                                                    id: item.id,
                                                    text: item.user
                                                }
                                            }) : []}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.latitude}
                                            type="text"
                                            label={translate('plant:fields.latitude')}
                                            id="latitude"
                                            name='latitude'
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.longitude}
                                            type="text"
                                            label={translate('plant:fields.longitude')}
                                            id="longitude"
                                            name='longitude'
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button onClick={() => handleSelected()} full = "true" text={translate('change-location:delete-selected')} secundary="true" />
                    </div>
                </div>
                <div id="list">
                    <ListPagination
                        disableRow={true}
                        page={props.plants?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            plants.map((item, index) => {
                                return renderItem(item, index);
                            })
                        }
                    />
                </div>
            </div>
            <Modal
                id={`modal-id-smallPartsFilterByPartnumber`}
                fixedFooter
                style={{ marginTop: "15px", maxHeight: "60%" }}
                actions={
                    <Row className="center" style={{ height: "60%" }}>
                        <Button onClick={() => onConfirmModal()} text={translate('confirm', 'general')} />
                        <Button onClick={() => setModalOpen(false)} text={translate('cancel', 'general')} secundary="true"/>
                    </Row>
                }
                open={modalOpen}>
                <div>
                    <Row className="center">
                        <div className="sixth-text-color center">
                            <span className="col s12">
                                <i className="material-icons large">info_outline</i>
                            </span>
                            <span className="title col s12">{translate('messages.confirmation-delete-list', 'plant')}</span>
                        </div>
                    </Row>
                    {selectedItems.map((item, index) => {
                            return (
                                <div
                                    style={{ display: 'block', padding: '10px', height: 'auto' }}
                                    key={`oi-${index}`}
                                >
                                    <span className="sixth-text-color" style={{ display: 'block' }}>{item.name}</span>
                                </div>
                            );
                    })}
                </div>
            </Modal>
        </div>
    );
};

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog),
        user: state.userReducer.user,
        plants: state.plantReducer.plants
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPlants: (vision, filter, pagination) => {
            dispatch(PlantService.getPlants(vision, filter, pagination));
        },
        setPlant: (plant) => {
            dispatch(plantAction.setPlant(plant));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(PlantService.DeleteSelectedPlants(selectedIds, callback));
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PlantList));
